import { render, staticRenderFns } from "./SectionDropdown.vue?vue&type=template&id=5b93d2ab&"
import script from "./SectionDropdown.vue?vue&type=script&lang=ts&"
export * from "./SectionDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./SectionDropdown.vue?vue&type=style&index=0&id=5b93d2ab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports